import { DateTime } from 'luxon';
import { Citizenship } from 'shell/models/person/citizenship';
import { CitizenshipVM } from 'shell/view-models/citizenship';

export const transformCitizen = (values: CitizenshipVM | undefined): Citizenship | undefined => {
  const originReturnData: Citizenship | undefined =
    !values?.code && !values?.validityDate && !values?.citizenship && !values?.note
      ? undefined
      : {
          codiceStato: values?.code || undefined,
          dataValidita: values?.validityDate
            ? DateTime.fromFormat(values.validityDate, 'dd/MM/yyyy').toFormat('yyyy-MM-dd')
            : undefined,
          descrizioneStato: values?.citizenship || undefined,
          noteStato: values?.note || undefined,
        };

  return originReturnData;
};
